import { render, staticRenderFns } from "./TipTapEditor.vue?vue&type=template&id=1c4b8c11&"
import script from "./TipTapEditor.vue?vue&type=script&lang=js&"
export * from "./TipTapEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports